export const licitaciones2026 = [
  {
    titulo: "CONVOCATORIA 01-2026",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N1-2026",
      },
      {
        informacionTitulo: "EA-913005999-N2-2026",
      },
      {
        informacionTitulo: "EA-913005999-N3-2026",
      },
      {
        informacionTitulo: "EA-913005999-N4-2026",
      },
      {
        informacionTitulo: "EA-913005999-N5-2026",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 02-2026",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N6-2026",
      },
      {
        informacionTitulo: "EA-913005999-N7-2026",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 03-2026",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N8-2026",
      },
      {
        informacionTitulo: "EA-913005999-N9-2026",
      },
      {
        informacionTitulo: "EA-913005999-N10-2026",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 04-2026",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N11-2026",
      },
      {
        informacionTitulo: "EA-913005999-N12-2026",
      },
      {
        informacionTitulo: "EA-913005999-N13-2026",
      },
      {
        informacionTitulo: "EA-913005999-N14-2026",
      },
      {
        informacionTitulo: "EA-913005999-N15-2026",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 05-2026",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N16-2026",
      },
      {
        informacionTitulo: "EA-913005999-N17-2026",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 06-2026",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N18-2026",
      },
      {
        informacionTitulo: "EA-913005999-N19-2026",
      },
      {
        informacionTitulo: "EA-913005999-N20-2026",
      },
      {
        informacionTitulo: "EA-913005999-N21-2026",
      },
      //{
        //informacionTitulo: "EA-913005999-N15-2026",
      //},
    ],
  },
  {
    titulo: "CONVOCATORIA 01-2026 OBRA",
    subtitulo: [
      {
        informacionTitulo: "CAASIM-HGO-L.O.P.-01-2026",
      },
      {
        informacionTitulo: "CAASIM-HGO-L.O.P.-02-2026",
      },
      {
        informacionTitulo: "CAASIM-HGO-L.O.P.-03-2026",
      },
      //{
        //informacionTitulo: "EA-913005999-N21-2026",
      //},
      //{
        //informacionTitulo: "EA-913005999-N15-2026",
      //},
    ],
  },
  {
    titulo: "CONVOCATORIA 07-2026",
    subtitulo: [
       {
         informacionTitulo: "EA-913005999-N22-2026",
       },
       {
         informacionTitulo: "EA-913005999-N23-2026",
       },
      {
        informacionTitulo: "EA-913005999-N24-2026",
      },
      {
        informacionTitulo: "EA-913005999-N25-2026",
      },
      {
        informacionTitulo: "EA-913005999-N26-2026",
      },
      {
        informacionTitulo: "EA-913005999-N27-2026",
      },
      {
        informacionTitulo: "EA-913005999-N28-2026",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 02-2026 OBRA",
    subtitulo: [
      {
        informacionTitulo: "CAASIM-HGO-L.O.P.-04-2026",
      },
      // {
      //   informacionTitulo: "CAASIM-HGO-L.O.P.-02-2026",
      // },
      // {
      //   informacionTitulo: "CAASIM-HGO-L.O.P.-03-2026",
      // },
      //{
        //informacionTitulo: "EA-913005999-N21-2026",
      //},
      //{
        //informacionTitulo: "EA-913005999-N15-2026",
      //},
    ],
  },
];
